import React from 'react';
import ScreenSection from '../screen-section/ScreenSection';
import SectionTitle from '../section-title/SectionTitle';
import ContentContainer from '../content-container/ContentContainer';

import styles from './PartnersScreen.module.scss';
import PartnerLogo from '../partner-logo/PartnerLogo';

import todaykz from './assets/today-kz.svg';
import belnovosti from './assets/belnovosti.svg';
import wallstreet from './assets/wall-street.svg';
import forbes from './assets/forbes.svg';
import milligazete from './assets/milligazete.svg';
import ziare from './assets/ziare.svg';

const PartnersScreen = ({ id }) => (
  <ScreenSection theme="dark" id={id}>
    <div className={styles.root}>
      <div className={styles.centered}>
        <ContentContainer width="narrow">
          <SectionTitle>
            Our media
            <br />
            partners
          </SectionTitle>

          <div className={styles.content}>
            <div className={styles.grid}>
              <div className={styles.gridItem}>
                <PartnerLogo title="Today.kz" src={todaykz} />
              </div>
              <div className={styles.gridItem}>
                <PartnerLogo title="Белновости" src={belnovosti} />
              </div>
              <div className={styles.gridItem}>
                <PartnerLogo title="WALL-STREET" src={wallstreet} />
              </div>
              <div className={styles.gridItem}>
                <PartnerLogo title="Forbes" src={forbes} />
              </div>
              <div className={styles.gridItem}>
                <PartnerLogo title="MILLIGazete" src={milligazete} />
              </div>
              <div className={styles.gridItem}>
                <PartnerLogo title="Ziare.com" src={ziare} />
              </div>
            </div>
          </div>
        </ContentContainer>
      </div>
    </div>
  </ScreenSection>
);

export default PartnersScreen;
